export const source = 'srp';

export enum SearchDispatcherEvent {
  AppliedFilters = 'applied_filters',
  CompletedSavedSearch = 'complete_saved_search', // TODO: Replace with `DispatcherEvent.SavedSearchSaved`
  DismissBanner = 'dismiss_banner',
  DismissEarthDayBanner = 'dismiss_earth_day_banner',
  DismissEVBanner = 'dismiss_ev_banner',
  DismissPriceDrop = 'dismiss_price_drop',
  NewInventory = 'new_inventory',
  SaveSearch = 'save_search'
}
